module.exports = __webpack_public_path__ + "img/not-found-person.f5ba1fcf.png";